import { FaWhatsapp } from "react-icons/fa";
import { motion } from "framer-motion";

const PHONE = "34608916357"; // <-- tu número en formato internacional
const DEFAULT_MSG = "Hola! Quiero información sobre Applaby, ¿me ayudáis?";

export default function WhatsappFloat() {
	const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(DEFAULT_MSG)}`;

	return (
		<motion.a
			href={href}
			target="_blank"
			rel="noopener noreferrer"
			aria-label="Contactar por WhatsApp"
			initial={{ scale: 0.9, opacity: 0 }}
			animate={{ scale: 1, opacity: 1 }}
			transition={{ duration: 0.35 }}
			className="relative w-14 h-14 flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg hover:shadow-2xl hover:scale-105 transition group"
		>
			{/* Tooltip */}
			<div className="hidden sm:flex items-center justify-center absolute -left-44 bottom-1/2 translate-y-1/2 bg-white text-sm text-gray-800 rounded-full px-3 py-2 shadow-sm opacity-0 group-hover:opacity-100 transition-all">
				¿Hablamos por WhatsApp?
			</div>

			{/* Icono oficial */}
			<FaWhatsapp size={28} />
		</motion.a>
	);
}
